import type { FaireProductEntity } from "../../entity_types/product";

export const p_cdub6vvt95: FaireProductEntity = {
  token: "p_cdub6vvt95",
  type: "product",
  name: "5pc Tiger Eye Spheres ~ Polished Crystals & Minerals ~ Gifts",
  brandToken: "b_t2bh3wmq82",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/8118f8dc5d6d5db459b2d2df59afce3dfa5d4a2db72a4c1c0ceb59280e1c9bd5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bf39c25ffd24b0858d9d4a3388f23414f0ac26fc9d4f2a5b8cd28ce6f6eab083.jpeg",
    "https://cdn.faire.com/fastly/1318f54f9c2baaac24a3ff5573195dd1cb98a08d5b00241362cf3275c0e27a1b.jpeg",
    "https://cdn.faire.com/fastly/4ea4cbe19c7f52a0cd82020a55bc699256d59a8cab3587b518699a29fbba4193.jpeg",
    "https://cdn.faire.com/fastly/5e8628544091437902cb769109c65a3db9445999158877441a89b8b9045b1d7e.jpeg",
    "https://cdn.faire.com/fastly/cc0ffbae10b92fc54f7fe3544f7b56e460058981cc4c90dcf45057aa5bdc9f4b.jpeg",
    "https://cdn.faire.com/fastly/8556c57f5d6792a7d6f15f4c55481d1249a663ae4ccc9fa0366eb814ea2f19b7.jpeg",
  ],
  priceDollars: 36.03,
  description:
    "This listing is for 5 pieces of Tiger Eye from India.\n\nTiger Eye is known as a stone of protection, strength, and confidence. Believed to enhance focus, promote courage, and balance emotions, it is often associated with the root and solar plexus chakras. This golden-brown stone is cherished for its ability to inspire motivation, dispel fear, and foster a sense of stability and determination. \n\nScientifically, Tiger Eye is a variety of quartz (SiO₂) with parallel fibers of crocidolite that have been replaced by silica, giving it its characteristic chatoyancy, or “cat’s eye” effect. Historically, tiger eye was used by ancient Roman soldiers as a talisman for protection and strength in battle. Tiger Eye has a Mohs hardness of 6.5 to 7.",
  tags: [],
  msrpDollars: 72.06,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:21.102Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
